const TYPE = "ROCKY_CARD";
export const START_CARD_MODELING = `${TYPE}/start_card__modeling`;
export const AUTO_GET_CARD_VERIFICATIONS = `${TYPE}/auto_get_card_verifications`;